import { FC, PropsWithChildren, ReactNode, Suspense } from "react";
import { Provider } from "react-redux";
import { store } from "../../app/store";
import ComponentWrapper from "../ComponentWrapper";
import SuspenseLoader from "../SuspenseLoader";

interface IslandCompoundWrapperProps {
  component: ReactNode;
}

const IslandCompoundWrapper: FC<PropsWithChildren<IslandCompoundWrapperProps>> = (props) => {
  return (
    <Provider store={store}>
      <Suspense fallback={<SuspenseLoader />}>
        <ComponentWrapper>
          {props.component}
        </ComponentWrapper>
      </Suspense>
    </Provider>
  );
};

export default IslandCompoundWrapper;
